import NewsCreationScreen from "@/src/screens/news/news-creation-screen/news-creation-screen";

export default function NewsCreation() {
  return <NewsCreationScreen />;
}
